import { motion } from "framer-motion";

const HeroSection = ({ onBookNow }) => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden pt-16 sm:pt-20">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1724862743898-88d13df92100?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxlbGVjdHJpYyUyMGNhciUyMGNpdHklMjByb2FkJTIwc3VucmlzZSUyMG1pbmltYWx8ZW58MHx8fHwxNzc1NDUyNjA3fDA&ixlib=rb-4.1.0&q=85"
          alt="Premium EV"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-sarathi-background/80 via-sarathi-background/60 to-sarathi-background"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-12 sm:py-20 w-full">
        <div className="text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="font-outfit text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-none text-white mb-4 sm:mb-6">
              Sarathi-X
            </h1>
            <p className="text-sarathi-text-secondary text-base sm:text-lg md:text-xl max-w-2xl mx-auto leading-relaxed mb-8">
              Premium airport transfers designed to be the easiest part of your day.
            </p>

            {/* CTA — visible on mobile, hidden on desktop (header has it) */}
            {onBookNow && (
              <button
                type="button"
                onClick={onBookNow}
                className="md:hidden inline-flex items-center gap-2 bg-sarathi-primary hover:bg-sarathi-primary-hover text-white font-semibold px-8 py-3.5 rounded-full text-base transition-colors"
                data-testid="hero-book-btn"
              >
                Book a Ride
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}><path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"/></svg>
              </button>
            )}
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator — desktop only */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden sm:block"
      >
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2">
          <motion.div
            animate={{ y: [0, 12, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="w-1.5 h-1.5 bg-sarathi-primary rounded-full"
          />
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
